import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import DeleteIcon from "@material-ui/icons/Delete";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import DoneIcon from "@material-ui/icons/Done";
import moment from "moment";
import {
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Grid,
  Box,
} from "@material-ui/core";

import { Spinner, Layout } from "../../components";
import { updateComment } from "../../services/comments.service";

import { ModalEditComment } from "./modal.edit.comment";

import { domain } from "../../helpers/variables";

import "./comments.style.scss";

export const Comments = () => {
  const [open, setOpen] = useState(false);

  const [commentSelected, setCommentSelected] = useState();
  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const { listComments, isLoading } = useSelector((store) => store.comments);

  useEffect(() => {
    
    dispatch({ type: "FETCH_RECENTS_COMMENTS" });

  }, [dispatch]);

  const openModalWithComment = (comment) => {
    setCommentSelected(comment);
    setOpen(true);
  };

  const updateStatus = async (comment, published) => {
    const commentUpdatedStatus = { ...comment, published };
    try {
      await updateComment(commentUpdatedStatus);
      dispatch({ type: "FETCH_RECENTS_COMMENTS" });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Layout className="main comments">
      <Grid container>
        <Grid item md={10}>
          <h1>Comentários</h1>
        </Grid>
        <Grid item md={12}>
          <Paper>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Comentário</TableCell>
                  <TableCell align="center">Autor</TableCell>
                  <TableCell align="center">Data</TableCell>
                  <TableCell align="center">Publicado</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell>
                      <Spinner />
                    </TableCell>
                  </TableRow>
                ) : (
                  listComments?.length > 0 &&
                  listComments.map((comment, i) => (
                    <TableRow key={i}>
                      <TableCell
                        component="th"
                        scope="row"
                        className="comments__list__comment"
                      >
                        <small>{comment.content}</small>
                        <div>
                          <a
                            href={`${domain}${comment.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <small>{comment.url}</small>
                          </a>
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        {comment.author.user}
                      </TableCell>
                      <TableCell align="center">
                        {moment(comment.createdAt).format("DD/MM")}
                      </TableCell>
                      <TableCell align="center">
                        {comment.published ? (
                          <CheckIcon color="primary" />
                        ) : (
                          <CloseIcon color="secondary" />
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {user.uid === "LqUv8lkoDAZJ4MsIJQBI5X5fbD53" && (
                          <Box display="flex">
                            <EditIcon
                              onClick={() => openModalWithComment(comment)}
                              titleAccess="Editar"
                              color="primary"
                              style={{ marginRight: "10px", cursor: "pointer" }}
                            />
                            {comment.published ? (
                              <DeleteIcon
                                color="primary"
                                onClick={() => updateStatus(comment, false)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <DoneIcon
                                color="primary"
                                onClick={() => updateStatus(comment, true)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
      {open && (
        <ModalEditComment
          open={open}
          comment={commentSelected}
          setOpen={setOpen}
        />
      )}
    </Layout>
  );
};

export default Comments;
